import React, { useState, useEffect } from 'react';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useScreenSize from '../hooks/useScreenSize';
const Benefits = ({
  heading,
  backgroundColor,
  body,
  featureImage,
  id,
  index,
  slug,
  backgroundImage,
  backgroundImageMobile,
  buttonText,
  buttonPath,
  button,
  appDownload,
  buttonMedia,
  imagePlaceholder,
  secondaryBody,
  internalTitle,
}) => {
  const screenSize = useScreenSize();
  return (
    <>
      {/* PurgeCSS include: Yellow, White, Black */}
      {body && (
        <div
          className={`benefits-content-wrapper ${backgroundColor} `}
          id={`${id}`}
          key={index}
        >
          <div
            className={
              backgroundImage
                ? 'benefits-inner-secondary'
                : `benefits-inner ${slug === 'gaming' && 'reverse'} ${
                    slug === 'families' && 'padded'
                  }`
            }
          >
            {backgroundImage && (
              <div className="benefits-background-image">
                <LitImage
                  image={
                    screenSize.width >= 800
                      ? backgroundImage
                      : backgroundImageMobile
                  }
                  alt="boy playing on computer"
                />
              </div>
            )}
            <div className="benefits-content">
              {heading?.value && <LitStructuredText data={heading} basic />}
              {body?.value && <LitStructuredText data={body} basic />}
              {secondaryBody?.value && (
                <LitStructuredText data={secondaryBody} basic />
              )}
              {buttonText && (
                <div className="benefits-button-container">
                  {buttonText === 'Download the manual' ? (
                    <a
                      href={buttonMedia.url}
                      target="_blank"
                      className="button"
                    >
                      {buttonText}
                    </a>
                  ) : (
                    <Link to={`${buttonPath}`} className="button">
                      {buttonText}
                    </Link>
                  )}
                </div>
              )}
              <div
                className="app-download-container"
                id="#appDownloadContainer"
              >
                {internalTitle === 'App - Download' &&
                  appDownload.map(({ appUrl, appIcon }, index) => {
                    return (
                      <a href={appUrl} target="_blank" key={index}>
                        <LitImage image={appIcon} />
                      </a>
                    );
                  })}
              </div>
              {backgroundImage && (
                <a
                  href="https://uk.trustpilot.com/review/litfibre.com"
                  target="_blank"
                  className="button"
                >
                  See what others have to say
                </a>
              )}
            </div>
            {!backgroundImage && featureImage ? (
              <div className="benefits-image-container">
                <LitImage image={featureImage} alt="image" />
              </div>
            ) : (
              <div className="benefits-image-container">
                <FontAwesomeIcon icon={imagePlaceholder} />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Benefits;
